import React, { useState } from "react";

import classNames from "classnames";

import { Tab, Typography } from "clearsense-ui/components";

import DifferentialTable from "./DifferentialTable";
import Snapshot from "./Snapshot";

import { CONTENT_TABS, PROFILE_KEYS } from "../constants";

const Content = ({ data, setActiveTab }) => {
  const [contentActiveTab, setContentActiveTab] = useState("differentialTable");
  const { description } = data;
  return (
    <div className="space-y-3">
      <Typography style="medium">{description.description}</Typography>
      <div className="bg-yellow-50 p-4 my-2">
        {PROFILE_KEYS.map((key, index) => (
          <div key={index} className="flex">
            <Typography style="medium" className="w-32">
              {key.label}
            </Typography>
            <Typography
              style="medium"
              className={classNames("text-primary-shade", {
                "cursor-pointer": key.isURL,
              })}
              onClick={() =>
                key.isURL && window.open(description[key.key], "_blank")
              }
            >
              {description[key.key]}
            </Typography>
          </div>
        ))}
      </div>
      <div>
        This structure is derived from{" "}
        <a
          className="text-primary-shade"
          target="_blank"
          href={description.baseDefinition}
          rel="noreferrer"
        >
          {description.type}
        </a>
        .
      </div>
      <div className="space-y-4">
        <Typography style="h3" type="semibold">
          Formal Views of Profile Content
        </Typography>
        <Tab style="secondary">
          {CONTENT_TABS.map((tab, index) => (
            <Tab.Item
              key={index}
              active={contentActiveTab === tab["tabName"]}
              onClick={() => setContentActiveTab(tab["tabName"])}
            >
              {tab["label"]}
            </Tab.Item>
          ))}
        </Tab>
        {contentActiveTab === "differentialTable" && (
          <DifferentialTable
            description={description}
            setActiveTab={setActiveTab}
          />
        )}
        {contentActiveTab === "snapshot" && (
          <Snapshot description={description} setActiveTab={setActiveTab} />
        )}
      </div>
    </div>
  );
};
export default Content;
